import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/admin/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#03281B] brand-stripe px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="admin-login-form">
        <div className="w-12 h-12 rounded-xl bg-[#008057] flex items-center justify-center text-white mb-4"><Lock size={24} /></div>
        <h1 className="font-display text-2xl font-extrabold text-[#03281B]">Admin Dashboard</h1>
        <p className="text-slate-500 text-sm mt-1">Sporting CP Camp San Diego 2027</p>
        {error && <div className="mt-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{error}</div>}
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-semibold text-[#03281B]">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-xl border-2 border-[#E2EBF0] px-3 py-2.5 focus:border-[#008057] outline-none" required />
          </div>
          <div>
            <label className="text-sm font-semibold text-[#03281B]">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full rounded-xl border-2 border-[#E2EBF0] px-3 py-2.5 focus:border-[#008057] outline-none" required />
          </div>
          <button data-testid="admin-submit" disabled={loading} className="w-full rounded-full bg-[#008057] hover:bg-[#054D34] text-white py-3 font-bold disabled:opacity-60">{loading ? "Signing in..." : "Sign In"}</button>
        </div>
      </form>
    </div>
  );
}
